var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _vm.hasAmount
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    class: { "px-1": _vm.$vuetify.breakpoint.mdAndUp },
                    attrs: {
                      label: _vm.$t("Amount"),
                      outlined: "",
                      error: _vm.amountError,
                      rules: [_vm.vr.primitives.required]
                    },
                    on: { input: _vm.releaseAmountError },
                    model: {
                      value: _vm.model.amount,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "amount", _vm._n($$v))
                      },
                      expression: "model.amount"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("bank-fields", { ref: "bankFields", attrs: { data: _vm.model } }),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                class: { "px-1": _vm.$vuetify.breakpoint.mdAndUp },
                attrs: {
                  label: _vm.$t("Reference"),
                  counter: 30,
                  outlined: "",
                  max: "30",
                  rules: [_vm.vr.primitives.stringLength(3, 30)]
                },
                model: {
                  value: _vm.model.reference,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "reference", $$v)
                  },
                  expression: "model.reference"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("ec-date-input", {
                key: _vm.model.dueDate,
                class: { "px-1": _vm.$vuetify.breakpoint.mdAndUp },
                attrs: { label: _vm.$t("DueDate"), required: "" },
                model: {
                  value: _vm.model.dueDate,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "dueDate", $$v)
                  },
                  expression: "model.dueDate"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }